// extracted by mini-css-extract-plugin
export var deliveryRow = "_q1-a";
export var fixedHeight = "_q1-4";
export var freightLogo = "_q1-9";
export var fullWidth = "_q1-3";
export var priceColumn = "_q1-5";
export var radioSelected = "_q1-7";
export var radioUnselected = "_q1-6";
export var selectedOption = "_q1-2";
export var selectedOptionContainer = "_q1-1";
export var selection = "_q1-0";
export var tallSkeletonText = "_q1-8";